// extracted by css-extract-rspack-plugin
export default {"responseButtonWrapper":"response-button-wrapper--QqJ6LgJeNAwA1iLp"};